export default "__VITE_ASSET__LYhfjWsd__"